import { createBraze } from '@outputinc/o-analytics'

const apiKey = import.meta.env.VITE_BRAZE_API_KEY
const baseUrl = import.meta.env.VITE_BRAZE_SDK_ENDPOINT

const brazeClient = createBraze(apiKey, baseUrl)

export { brazeClient }
